export enum DialogHeaderVariant {
  Default = 'default',
  Icon = 'icon',
}

export enum DialogHeaderStatus {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Neutral = 'neutral',
}
